// extracted by mini-css-extract-plugin
export var chevronIcon = "_ds-2";
export var teamName = "_ds-1";
export var teamSwitcherButton = "_ds-0";